/**
 * TeamLogo Component
 */

import React, { FC } from 'react';
import { TeamLogoProps, TeamLogoTypes, SpotLogoProps} from './teamLogo.types';
import Image from '../Image/image';
import Skeleton from '../Skeleton/skeleton';
import COLORS from '../../style/universal.color';
import { withTheme } from 'styled-components';

export const TeamLogoFallback: string = 'https://www.mlbstatic.com/team-logos/team-cap-on-light/000.svg';

export const constructTeamLogoURL: Function = (teamId: string | number, teamLogoType: string, darkMode?: boolean): string => {
  const baseUrl = `https://www.mlbstatic.com/team-logos`;
  return teamLogoType === 'team' ? `${baseUrl}/${teamId}.svg` : `${baseUrl}/team-${teamLogoType}-on-${darkMode ? 'dark' : 'light'}/${teamId}.svg`;
};

export const constructSpotTeamLogo: Function = (teamId: string | number, spotWidth: number): SpotLogoProps => ({
  '1x': `https://midfield.mlbstatic.com/v1/team/${teamId}/spots/${spotWidth}`,
  '2x': `https://midfield.mlbstatic.com/v1/team/${teamId}/spots/${spotWidth * 2}`,
  '3x': `https://midfield.mlbstatic.com/v1/team/${teamId}/spots/${spotWidth * 3}`
});

const TeamLogo: FC<TeamLogoProps> = (props: TeamLogoProps) => {

  const {
    src = '',
    teamId,
    teamLogoType = TeamLogoTypes.CAP,
    darkMode = false,
    rounded = false,
    errorImageSrc = TeamLogoFallback,
    backgroundColor = COLORS.transparent,
    theme = {},
    border,
    isLoading,
    width,
    height,
    skeletonRounded = false,
    dataAttr,
    alt
  } = props;
  let providedSrc: string = '';
  let providedSrcSet: object | undefined;
  const defaultTestIds: object = {'data-mlb-test': 'teamLogos', 'data-testid': 'teamLogos'};

  if (teamLogoType !== TeamLogoTypes.SPOT) {
    providedSrc = teamId ? constructTeamLogoURL(teamId, teamLogoType, darkMode || theme.dark) : src
  } else {
    const spotWidth: number = (typeof width !== 'undefined') ? +width : 0;
    const srcset = constructSpotTeamLogo(teamId, spotWidth);
    providedSrc = srcset['2x'];
    providedSrcSet = srcset;
  }

  if (teamId) {
    if (teamLogoType !== TeamLogoTypes.SPOT) {
      providedSrc = constructTeamLogoURL(teamId, teamLogoType, darkMode || theme.dark);
    } else {
      const spotWidth: number = (typeof width !== 'undefined') ? +width : 0;
      const srcset = constructSpotTeamLogo(teamId, spotWidth);
      providedSrc = srcset['2x'];
      providedSrcSet = srcset;
    }
  } else {
    providedSrc = src;
  }

  const TeamLogoUI = isLoading
    ? <Skeleton width={ width } height={ height || width } isCircle={ skeletonRounded || rounded } margin={ 0 } />
    : (
      <Image
        { ...props }
        key={teamId}
        src={ providedSrc }
        rounded={ rounded }
        errorImageSrc={ errorImageSrc }
        backgroundColor={ backgroundColor }
        border={ border }
        padding={ rounded && '10%' || undefined }
        dataAttr={{...defaultTestIds, ...dataAttr}}
        alt={alt}
        srcset={providedSrcSet}
      />
    );

  return TeamLogoUI;
};

export default withTheme(TeamLogo);
